var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "特别提示",
        width: "540px",
        loading: _vm.loading,
        height: "auto",
        top: _vm.top,
      },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        { staticClass: "liveLink" },
        [
          _c("div", { staticClass: "tips" }, [
            _c("i", { staticClass: "el-icon-warning tipsIcon" }),
            _c("div", { staticClass: "tipsContent" }, [
              _c("div", { staticClass: "tipsTitle" }, [_vm._v("注意")]),
              _c("div", { staticClass: "tipsMsg" }, [
                _vm._v(
                  "该链接未带助教老师标识，不可以作为邀课链接使用，如果复制发给学员，老师直播间将无法区分该学员是由哪个老师邀请过来的。"
                ),
              ]),
            ]),
          ]),
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "demo-ruleForm m-t-20",
              attrs: { model: _vm.form, size: "small", "label-width": "auto" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "链接地址：", prop: "link" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "400px" },
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.link,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "link", $$v)
                      },
                      expression: "form.link",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "二维码：", prop: "link" } },
                [
                  _c(
                    "span",
                    { attrs: { id: "liveLinkCode" } },
                    [
                      _vm.logoUrls[1]
                        ? _c("AppQrcode", {
                            attrs: {
                              "logo-scale": 0.2,
                              "correct-level": 3,
                              src: _vm.form.link,
                              size: 200,
                              margin: 10,
                              "logo-src": _vm.logoUrls[1],
                              "logo-margin": 5,
                            },
                          })
                        : _c("AppQrcode", {
                            attrs: {
                              src: _vm.form.link,
                              size: 200,
                              margin: 10,
                            },
                          }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "ss-material-box-bottom",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "clipboard",
                  rawName: "v-clipboard:copy",
                  value: _vm.form.link,
                  expression: "form.link",
                  arg: "copy",
                },
                {
                  name: "clipboard",
                  rawName: "v-clipboard:success",
                  value: _vm.clipboardSuccess,
                  expression: "clipboardSuccess",
                  arg: "success",
                },
              ],
              staticClass: "m-l-20",
              attrs: { size: "small", type: "primary" },
            },
            [_vm._v("复制链接")]
          ),
          _c(
            "el-button",
            {
              staticClass: "btn_primary",
              attrs: { size: "small" },
              on: { click: _vm.onhandleDownCode },
            },
            [_vm._v("下载二维码")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }